<footer>
  <div class="content-wrapper">
    <div class="float-left">
      <app-version></app-version>
      <p class="copyright">&copy;{{'FOOTER' | translate}}</p>
    </div>
  </div>
</footer>
